var angular = require('angular');
var _module = angular.module('benoit');
var $ = require('jquery');

_module.filter('embedResponsive', [
    '$log',

    function ($log) {
        return function (str) {
            var $html = $(['<div>', str, '</div>'].join(''));
            var videoPlayerSites = [
                'youtube\.com',
                'vimeo\.com'
            ];
            var videoEmbedRegex = new RegExp('(' + videoPlayerSites.join('|') + ')', 'gi');

            $html.find('iframe').each(function (i, iframe) {
                iframe = $(iframe);
                var src = iframe.attr('src');

                if(src.match(videoEmbedRegex)) {
                    iframe.attr({
                        width: null,
                        height: null
                    });
                    iframe.addClass('embed-responsive-item');
                    iframe.wrap('<div class="embed-responsive embed-responsive-16by9" />');
                } else {
                    iframe.attr({
                        width: '100%'
                    });
                }
            });

            return $html.html();
        };
    }
]);
